export function hasClass(el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return
  }

  let newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

export function removeClass(el,className) {
  if(hasClass(el,className)){
    let newClass = el.className.split(' ')
    for(var i=0;i<newClass.length;i++){
      if(newClass[i]==className){
        newClass.splice(i,1)
      }
    }
    el.className = newClass.join(' ')
  }
}

export function getData(el, name, val) {
  const prefix = 'data-'
  if (val) {
    return el.setAttribute(prefix + name, val)
  }
  return el.getAttribute(prefix + name)
}

let element = document.createElement('div').style

function elementStyle() {
  let transformName = {
    o : 'oTransform',
    ms : 'msTransform',
    moz : 'mozTransform',
    webkit : 'webkitTransform',
    stander : 'oTransform'
  } 

  for(let key in transformName){
    if(element[transformName[key]]!==undefined){
      return key
    }
  }

  return false
}

export function prefixStyle(style) {
  let vendor=elementStyle();
  if(vendor===false){
    return false
  }
  return vendor+style.charAt(0).toUpperCase()+style.substring(1)
}




// WEBPACK FOOTER //
// ./src/common/js/dom.js